module.exports = __webpack_public_path__ + "static/a-centro-obstetrico-b24ec1b5cdecdbdf7bea9295e58682d3.jpg";